const mimeToExtensionMap: Record<string, string> = {
  "video/mp4": "mp4",
  "video/quicktime": "mov",
  "video/webm": "webm",
  "video/x-msvideo": "avi",
  "video/x-matroska": "mkv",
  "video/ogg": "ogv",
};

export const getFileExtensionFromMime = (mimeType: string): string => {
  return mimeToExtensionMap[mimeType] || "mp4";
};
